// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sk86","label":"styles_label__1RLWh"};